<script lang="ts" setup>
import { ref, onMounted, watch } from "vue";

const classicEditor = ref<Promise<any>>();
const editorContent = ref("");
const interval = ref<any>(null);

const emit = defineEmits(["onChange"]);

const prop = defineProps({
  config: {
    type: Object,
    default: () => { },
  },
  id: {
    type: String,
    default: "editor",
  },
  data: {
    type: String,
    default: undefined
  }
});

onMounted(() => {
  prepareCKEditor();
});

watch(editorContent, (value: any) => {
  if (interval.value) {
    clearTimeout(interval.value);
  }

  interval.value = setTimeout(() => {
    emit("onChange", value);
  }, 0);
});

watch(
  () => prop.data,
  (newData) => {
    if (classicEditor.value) {
      classicEditor.value.then((editor) => {
        if (editor && editor.getData() !== newData) {
          editor.setData(newData); // Update editor content
        }
      });
    }
  }
);

const prepareCKEditor = async () => {
  if (typeof window !== "undefined") {
    const { default: ClassicEditor } = await import(
      "@ckeditor/ckeditor5-build-classic",
    );
    const editorElement: HTMLElement | null = document.querySelector(
      `#${prop.id}`
    );
    if (ClassicEditor && editorElement) {
      classicEditor.value = ClassicEditor.create(
        editorElement,
        {
          ...prop.config,
          toolbar: {
            items: ['undo', 'redo',
              '|',
              'heading',
              '|',
              'bold', 'italic',
              '|',
              'link', 'blockQuote',
              '|',
              'bulletedList', 'numberedList', 'outdent', 'indent']
          }
        }
        // prop.config && {
        //   ...prop.config,
        // removePlugins: ['bold'],
        /** NEEDED FEATURE WILL GO HERE  */
        // toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
        // heading: {
        //     options: [
        //         { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        //         { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        //         { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
        //     ]
        // }
        // }
      )
        .then((editor: any) => {
          editor.setData(prop.data);
          editor.model.document.on("change:data", () => {
            if (editor) {
              editorContent.value = editor.getData();
            }
          });
          return editor;
        })
        .catch((error: Error) => {
          console.error("[failed at prepareCKEditor]", { error });
        });
    }
  }
};
</script>
<template>
  <div class="ckeditor-wrapper">
    <div :id="id"></div>
  </div>
</template>
